import { MatomoProvider } from "@jonkoops/matomo-tracker-react";
import { CssBaseline, adaptV4Theme } from "@mui/material";
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
  createTheme,
  responsiveFontSizes,
} from "@mui/material/styles";
import { ThemeProvider as StylesThemeProvider } from "@mui/styles";

import "./App.css";
import MatomoInstance from "./Provider";
import Routes from "./Routes";

const APP_DATA_VERSION = "0.1.2";

let theme = createTheme(
  adaptV4Theme({
    palette: {
      common: { black: "#000", white: "#fff" },

      background: { paper: "#fff", default: "#fafafa" },

      primary: {
        light: "rgba(76, 130, 230, 1)",
        main: "rgba(76, 130, 230, 1)",
        dark: "rgba(33,83,155,1)",
        contrastText: "#fff",
      },

      secondary: {
        light: "rgba(181, 186, 187, 1)",
        main: "rgba(109, 118, 119, 1)",
        dark: "rgba(54, 59, 59, 1)",
        contrastText: "#fff",
      },

      error: {
        light: "#e57373",
        main: "#f44336",
        dark: "#d32f2f",
        contrastText: "#fff",
      },

      text: {
        primary: "rgba(0, 0, 0, 0.87)",
        secondary: "rgba(0, 0, 0, 0.54)",
        disabled: "rgba(0, 0, 0, 0.38)",
        hint: "rgba(0, 0, 0, 0.38)",
      },
    },
  }),
);

theme = responsiveFontSizes(theme);

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <StylesThemeProvider theme={theme}>
          <MatomoProvider value={MatomoInstance}>
            <CssBaseline />
            <Routes />
          </MatomoProvider>
        </StylesThemeProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
}

export { APP_DATA_VERSION };

export default App;
